import { render, staticRenderFns } from "./SettingPhoneComponent.vue?vue&type=template&id=f629a02e&scoped=true"
import script from "./SettingPhoneComponent.vue?vue&type=script&lang=js"
export * from "./SettingPhoneComponent.vue?vue&type=script&lang=js"
import style0 from "./SettingPhoneComponent.vue?vue&type=style&index=0&id=f629a02e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f629a02e",
  null
  
)

export default component.exports